module.exports = __webpack_public_path__ + "5b8939ac5dee51f2f264203e1f3115c5.svg";